import type { NextDueOutput } from './schemas/dossiers.js';

const NBSP = String.fromCharCode(0xa0);

/** Kilométrage en clair, espaces insécables (« 35 000 km »), lisible aussi dans le PDF (police embarquée). */
export function formatMileageText(km: number): string {
  return `${String(Math.trunc(km)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP)}${NBSP}km`;
}

/**
 * Compte rendu de revente (08/10/2026) : prochaine échéance en clair, identique sur la page client, la fiche
 * dossier et le PDF. « Prochaine vidange : à 35 000 km ou en mars 2027 » ; une date au 1er du mois se lit
 * « en <mois> <année> », toute autre date « le <jour> <mois> <année> ». `null` sans date ni kilométrage.
 */
export function formatNextDue(next: NextDueOutput | null | undefined): string | null {
  if (!next || (next.date === null && next.mileage === null)) return null;
  const parts: string[] = [];
  if (next.mileage !== null) parts.push(`à ${formatMileageText(next.mileage)}`);
  if (next.date !== null) {
    const d = new Date(`${next.date}T12:00:00Z`);
    parts.push(
      next.date.endsWith('-01')
        ? `en ${new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', month: 'long', year: 'numeric' }).format(d)}`
        : `le ${new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', dateStyle: 'long' }).format(d)}`,
    );
  }
  return `${next.label ?? 'Prochaine échéance'} : ${parts.join(' ou ')}`;
}
